import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogHelper, HttpHelper } from 'nglhelper';
import { AuthService } from '../../common/services/authservice';
@Component({
    templateUrl: './changepassword.component.html',
    styleUrls: ['./changepassword.component.scss']
})
export class ChangePasswordComponent implements OnInit {

    passw = /^\S{8,20}/;   ///^(?=.*\d)(?=.*[A-Z]).{8,20}$/;
    model = {
        OldPassword: '',
        NewPassword: '',
        ConfirmNewPassword: ''
    }
    constructor(private router: Router, private http: HttpHelper, private dialog: DialogHelper, private auth: AuthService) {
    }

    ngOnInit() {
        //if (!this.jwt.Token)
        //    this.router.navigateByUrl("/login");
    }

    errorMessage = '';
    async submit() {
        this.errorMessage = this.validation();
        if (this.errorMessage)
            return;

        try {
            await this.http.Post("/api/account/changepassword", this.model);
            this.dialog.AlertSuccess("Password changed. Please login with your new password.");
            this.auth.SignOut();
            this.router.navigateByUrl("/login");
        }
        catch (err) {
            this.dialog.AlertError(err);
        }
    }

    validation() {
        if (!this.model.OldPassword)
            return 'Current Password is required.';

        if (!this.model.NewPassword)
            return 'New Password is required.';

        if (!this.model.ConfirmNewPassword)
            return 'Confirm password is required.';

        if (this.model.NewPassword != this.model.ConfirmNewPassword)
            return 'Confirm password not identical with new password.';

        if (this.model.OldPassword == this.model.NewPassword)
            return 'New Password cannot same with Old password';

        if (!this.passw.test(this.model.NewPassword))
            return 'New Password must be at least 8 alphanumeric characters.';
    }

}